import { render } from "./InfoMessage.vue?vue&type=template&id=6ea2f70c&scoped=true&ts=true&lang=pug"
import script from "./InfoMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoMessage.vue?vue&type=script&lang=ts&setup=true"

import "./InfoMessage.vue?vue&type=style&index=0&id=6ea2f70c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea2f70c"]])

export default __exports__